const TechSkills = () => {
    const skills = [
        {
            name: "Frontend Development",
            tech: "React.js, JavaScript, Next.js",
        },
        {
            name: "Data Structures and Algorithms",
            tech: "C++",
        },
        {
            name: "Backend Development",
            tech: "Node.js, Express.js",
        },
        {
            name: "Database",
            tech: "MongoDB, Firebase, MySQL",
        },
    ];

    return (
        <>
            {skills.map((skill, index) => (
                <div key={index} className="resume-project-content">
                    <div className="details-head">
                        <div className="details-head-left">{skill.name}</div>
                    </div>
                    <div className="details-info">{skill.tech}</div>
                </div>
            ))}
        </>
    );
};

export default TechSkills;
